import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import dynamic from "next/dynamic"
import { count, removeAfterSpace } from "../../config/helpers";
import dayjs from 'dayjs';
import { useState } from "react";


const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));

const Testimonials = (props) => {
    const {
        testimonials,
        template_page_settings,
    } = props;

    const [testimonialIndex, setTestimonialIndex] = useState(8);

    const increseTestimonialIndex = () => {
        setTestimonialIndex((prevState) => prevState+4)
    }

    return (
        (<BoxContainer template_page_settings={template_page_settings} className="mb-6 mt-3">
            <Typography className="text-center f-size_5 mb-3" component="h1" variant="h2">Testimonials - What Our Customers Say</Typography>
            <Typography className="text-center mb-4">{`At ${process.env.brand.brand_name} we value all the feedback we receive from our clients. Below are a selection of our testimonials.`}</Typography>
            {
                count(testimonials) > 0 ? (
                <>
                    <Grid spacing={3} container>
                        {testimonials.map((testimonial, idx) => (
                             idx < testimonialIndex && (
                                <Grid item xs={12} lg={6} key={idx}>
                                    <Box className="p-2" sx={{backgroundColor: '#ecf0f1'}}>
                                        <Box>
                                            <blockquote className="p-0 m-0">
                                            <Typography className="f-size_3 blockquote-p"><i>{testimonial.content}</i></Typography>
                                            </blockquote>
                                        </Box>
                                        <Box>
                                            <Typography color="primary" className="f-size_2 fw-bold">
                                                {dayjs(testimonial.date).format('DD/MM/YYYY')} - {removeAfterSpace(testimonial.customer)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                             )
                        ))}
                    </Grid>
                    {testimonialIndex < count(testimonials) && <Button onClick={increseTestimonialIndex} className="mt-3 ml-2" variant="contained">Load More</Button>}
                </>
                ) : (
                    <Typography>Sorry! No Testimonials have been found.</Typography>
                )

            }
        </BoxContainer>)
    );
}

export default Testimonials